const PANEL_CLIENT_CONCURRENCY = 3;

let active = 0;
const queue: Array<() => void> = [];

const release = () => {
  active -= 1;
  const next = queue.shift();
  if (next) {
    next();
  }
};

const acquire = async (): Promise<void> => {
  if (active < PANEL_CLIENT_CONCURRENCY) {
    active += 1;
    return;
  }
  await new Promise<void>((resolve) => {
    queue.push(() => {
      active += 1;
      resolve();
    });
  });
};

/** Очередь браузерных запросов к /strapi-internal, чтобы не забивать Strapi при открытии панели. */
export const withPanelStrapiConcurrency = async <T>(operation: () => Promise<T>): Promise<T> => {
  if (typeof window === 'undefined') {
    return operation();
  }
  await acquire();
  try {
    return await operation();
  } finally {
    release();
  }
};
